import React from "react";
import { NoDataComponent } from "../../../../../../ds";
import { DataResponse } from "../../../../business";
import { ProductFactory } from "../../../interfaces/factories";
import { ProductUpdateContent } from "./product-update/product-update-content.component.tsx";

export class ProductUpdateScreenFactoryImpl implements ProductFactory {
    create(data: DataResponse): React.ReactElement {
        if (data && data.success && data.response && Array.isArray(data.response)) {
            if (data.response.length === 0) {
                return <NoDataComponent />
            }
            return <ProductUpdateContent productData={data.response[0]} />
        }
        return <NoDataComponent />
    }
}